// @mui
import { Container, Grid } from '@mui/material';

import { observer } from 'mobx-react-lite';

//Localization
import useLocales from 'src/hooks/useLocales';
import Page from 'src/components/Page';
import useSettings from 'src/hooks/useSettings';
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import { PATH_DASHBOARD } from 'src/routes/paths';
import ElectricMeterDetailTableRow from './ElectricMeterDetailTableRow';
import { useStore } from 'src/stores/store';
import { useEffect, useState } from 'react';
import Loader from 'src/components/loader/Loader';

// ----------------------------------------------------------------------

export default observer(function ElectricMeterDetailHeader() {
  const { translate } = useLocales();
  const {
    ElectricMeterStore: {
      selectedElectricMeter,
      clearSelectedElectricMeter,
      ID,
      getElectricMeterFromRegistry,
    },
    ElectricityPaymentStore,
  } = useStore();
  const [isLoading, setIsLoading] = useState(true);
  const { GetElectricityPaymentHistory, ElectricityPaymentHistoryResult } = ElectricityPaymentStore;
  const { themeStretch } = useSettings();

  useEffect(() => {
    if (ID) {
      setIsLoading(true);
      getElectricMeterFromRegistry(ID);

      GetElectricityPaymentHistory({ electricmeterId: ID }).finally(() => setIsLoading(false)); // Ensure loading ends
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ID]);
  return (
    <Page title={translate('ElectricMeter.ElectricMeterDetails')}>
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading={translate('ElectricMeter.ElectricMeterDetails')}
          links={[
            { name: `${translate('Department.Dashboard')}`, href: PATH_DASHBOARD.root },
            {
              name: `${translate('ElectricMeter.ElectricMeterDetails')}`,
              href: PATH_DASHBOARD.ElectricMeter.list,
            },
          ]}
        />
        {isLoading ? ( // Show loading state
          <Grid container justifyContent="center" alignItems="center" style={{ height: '50vh' }}>
            <Loader /> {/* Replace with Loader */}
          </Grid>
        ) : selectedElectricMeter ? ( // Render details if available
          <Grid container>
            <ElectricMeterDetailTableRow
              row={selectedElectricMeter!}
              electricityRow={ElectricityPaymentHistoryResult}
              clearElectricMeter={clearSelectedElectricMeter}
            />
          </Grid>
        ) : ''}
      </Container>
    </Page>
  );
});

